<template>
  <div v-if="!done && current_group" class="refinement">
    <h1 class="refinement__description">
      You marked these images with score "
      <span>{{current_group.group}}</span>"
      <br />
      <small>Drag the images below to arrange them in order of preference, with your most preferred images being first. Then click the ‘next button’</small>
    </h1>

    <div class="refinement__done">
      <a class="btn btn-primary btn-lg" @click="saveOrders">Next</a>
    </div>

    <RefinementList
      ref="refinement_list"
      class="refinement__list"
      :show_footer="false"
      :show_index="true"
      @product-click="onProductClick"
    ></RefinementList>

    <div class="refinement__done">
      <a class="btn btn-primary btn-lg" @click="saveOrders">Next</a>
    </div>
  </div>
</template>
<script>
import RefinementList from '@src/components/survey/RefinementList.vue'

export default {
  components: {
    RefinementList
  },
  props: {},
  data() {
    return {
      groups: null,
      current_group: {},
      groupsGenerator: null,
      tmp_questions: [],
      results: [],
      done: false,
    }
  },
  methods: {
    onProductClick(product) {
      this.$emit('product-click', product);
    },
    // dragQuestion(from_idx, to_idx) {
    //   // keep questions in the same order here
    //   const temp = this.tmp_questions.splice(from_idx, 1)
    //   this.tmp_questions.splice(to_idx, 0, temp[0])
    // },
    activate(groups) {
      this.groups = groups
      this.groupsGenerator = this.groupsGeneratorFunc()
      this.activateNextGroup()
    },
    saveOrders() {
      this.results.push({
        group: this.current_group.group,
        questions: this.$refs.refinement_list.ids,
      })

      console.log(this.results)

      this.activateNextGroup()
      window.scrollTo(0, 0)
    },
    *groupsGeneratorFunc() {
      for (const group in this.groups) {
        console.log('next yield')
        yield this.groups[group]
      }
    },
    activateNextGroup() {
      const i = this.groupsGenerator.next()

      if (i.done) {
        this.$emit('refinement-done', this.results)
        this.done = true
      } else {
        this.current_group = i.value
        this.$refs.refinement_list.reacticate(i.value)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.refinement {
  &__list {
    
  }
  &__description {
    text-align: center;

    span {
      font-weight: bolder;
      color: orange;
    }

    small {
      font-size: 14px;
      line-height: 12px;
    }
  }

  &__done {
    a {
      width: 100%;
    }

    margin: 20px 0;
  }
}
</style>
